import Vue from 'vue'; // 引入 Vue
import BlogMessage from './BlogMessage.vue'; // 引入上边定义好的 message 模板
import ConfirmBoxVue from './Confirm.vue';
import ErrorMessage from './ErrMessage.vue'; // 引入上边定义好的 message 模板
const MessageBox = Vue.extend(BlogMessage); // 使用 Vue.extend 来创建一个构造器
const ConfirmExtend = Vue.extend(ConfirmBoxVue);
const ErrMessageBox = Vue.extend(ErrorMessage); // 使用 Vue.extend 来创建一个构造器


class MsgBox {

  constructor(instance, timer) {
    this.instance = instance;
    this.timer = timer;
  }
  /**
   * 显示提示消息框
   * @param {string} msg 提示信息
   * @param {string} type 显示消息框样式
   * @param {number} duration 显示时间 秒为单位
   */
  show(msg, type, duration = 5) {
    // 如果当前定时器已开启, 说明页面上已经有一个 message-box 了, 则不能再继续创建新的 message-box
    if (this.timer) return;
    const options = {
      message: msg,
      type: type,
      duration: duration * 1000,
      cancel: () => {
        this.hide()
      }
    };

    // 初始化实例, 并将 options 作为新的 data 传入, Vue 会将 options 合并到原有的 data 上, 覆盖原有的默认值, 但是, 在 options 中没有设置的是不会被改变的
    this.instance = new MessageBox({
      data: options,
      el: document.createElement('div')
    });
    // 使用原生 JS 的 API 将当前实例的真实 DOM 追加到 body下面的app里面，这样才能用到vuetify里面的颜色或者主题
    document.getElementById('app').appendChild(this.instance.$el);
    Vue.nextTick(() => {
      // document.body.appendChild(instance.vm.$el);
      // 实例上的 vm 就是我们的 Vue 组件, 所以我们可以通过 vm 访问到当前实例中的所有属性
      // 将 visible 设置为 true, 即显示当前 message-box
      this.instance.visible = true;
    })


    // 开启定时器
    this.timer = setTimeout(() => {
      this.hide()
    }, this.instance.duration);
  }

  /**
   * 隐藏消息框
   */
  hide() {

    this.instance.visible = false;
    // 在时间结束后将当前实例手动卸载
    this.instance.$destroy();
    // console.log(this.instance, 11)
    // 使用原生 API 将当前实例生成的 DOM 节点在真实的 DOM 树中删除
    this.instance.$el.parentNode.removeChild(this.instance.$el);
    // 清除定时器
    clearTimeout(this.timer);
    this.timer = null;
  }


}

class ConfirmBox {

  constructor(confirmInst) {
    this.confirmInst = confirmInst;
  }

  /**
   * 显示询问弹窗
   * @param {*} msg 询问消息
   * @param {*} agreeFun 同意函数
   * @param {*} cancelFun 取消函数
   */
  show(msg, agreeFun, cancelFun) {

    this.confirmInst = new ConfirmExtend({
      data: {
        agree: () => {
          this.hide()
          if (agreeFun) {
            agreeFun();
          }
        },
        cancel: () => {
          this.hide()
          if (cancelFun) {
            cancelFun();
          }
        }
      },
      propsData: { msg },
      el: document.createElement('div')
    });

    console.log(this.confirmInst.$el, 99)

    // 使用原生 JS 的 API 将当前实例的真实 DOM 追加到 body下面的app里面，这样才能用到vuetify里面的颜色或者主题
    // document.getElementById('app').appendChild(this.confirmInst.$el);

    Vue.nextTick(() => {
      this.confirmInst.dialog = true;
    })

  }

  /**
   * 隐藏消息框
   */
  hide() {
    this.confirmInst.$el.dialog = false;
    // 在时间结束后将当前实例手动卸载
    this.confirmInst.$destroy();
  }
}

class ErrMsgBox {

  constructor(instance, timer) {
    this.instance = instance;
    this.timer = timer;
  }
  /**
   * 显示提示消息框
   * @param {string} msg 提示信息
   * @param {string} type 显示消息框样式
   * @param {number} duration 显示时间 秒为单位
   */
  show(msg, type, duration = 5) {
    // 如果当前定时器已开启, 说明页面上已经有一个 message-box 了, 则不能再继续创建新的 message-box
    if (this.timer) return;
    const options = {
      message: msg,
      type: type,
      duration: duration * 1000,
      cancel: () => {
        this.hide()
      }
    };

    // 初始化实例, 并将 options 作为新的 data 传入, Vue 会将 options 合并到原有的 data 上, 覆盖原有的默认值, 但是, 在 options 中没有设置的是不会被改变的
    this.instance = new ErrMessageBox({
      data: options,
      el: document.createElement('div')
    });
    // 使用原生 JS 的 API 将当前实例的真实 DOM 追加到 body下面的app里面，这样才能用到vuetify里面的颜色或者主题
    document.getElementById('app').appendChild(this.instance.$el);
    Vue.nextTick(() => {
      // document.body.appendChild(instance.vm.$el);
      // 实例上的 vm 就是我们的 Vue 组件, 所以我们可以通过 vm 访问到当前实例中的所有属性
      // 将 visible 设置为 true, 即显示当前 message-box
      this.instance.visible = true;
    })


    // 开启定时器
    this.timer = setTimeout(() => {
      this.hide()
    }, this.instance.duration);
  }

  /**
   * 隐藏消息框
   */
  hide() {

    this.instance.visible = false;
    // 在时间结束后将当前实例手动卸载
    this.instance.$destroy();
    // console.log(this.instance, 11)
    // 使用原生 API 将当前实例生成的 DOM 节点在真实的 DOM 树中删除
    this.instance.$el.parentNode.removeChild(this.instance.$el);
    // 清除定时器
    clearTimeout(this.timer);
    this.timer = null;
  }


}

const Message = new MsgBox()
const Confirm = new ConfirmBox()
const ErrMessage = new ErrMsgBox()


/**
 * Vue插件安装函数
 * @param {Object} Vue Vue对象
 */
const install = (Vue) => {
  Vue.prototype.$message = Message;
  Vue.prototype.$confirm = Confirm;
  Vue.prototype.$errmessage = ErrMessage;
}



// 最终抛出一个对象, 对象上我们可以使用 install 来扩展 Vue 的插件
// 当我们的对象上有 install 方法的时候, 它接收第一个参数为 Vue,
// 我这里为了方便使用, 还在当前抛出的对象上定义了一个 message 方法, 为了方便在 axios 的拦截器中使用;
export {
  install,
  Message,
  Confirm,
  ErrMessage
};
